import { createClient } from "../client"

type ConversationStatus = 'open' | 'closed' | 'pending'

export async function getConversationById(conversationId: string) {
    const supabase = createClient()
    
    return await supabase
        .from('support_conversations')
        .select('*')
        .eq('id', conversationId)
        .single()
}

export async function getUserConversations() {
    const supabase = createClient()
    
    return await supabase
        .from('support_conversations')
        .select('*')
        .order('createdAt', { ascending: false })
}

export async function getAdminConversations(
    status?: ConversationStatus
) {
    const supabase = createClient()
    
    let query = supabase
        .from('support_conversations')
        .select('*')
    
    if (status) {
        query = query.eq('status', status)
    }
    
    return await query.order('createdAt', { ascending: false })
}

export async function updateConversationStatus(
    conversationId: string, 
    status: ConversationStatus
) {
    const supabase = createClient()
    
    return await supabase
        .from('support_conversations')
        .update({ status })
        .eq('id', conversationId)
}

export async function createConversation() {
    const supabase = createClient()
    
    return await supabase
        .from('support_conversations')
        .insert({
            status: 'open',
            metadata: {
                tags: [],
                priority: 'normal',
                notes: '',
                starred: false
            }
        })
        .select()
        .single()
}

export async function getOrCreateConversation() {
    const supabase = createClient()
    
    // First try to get an existing open conversation
    const { data: existingConversation } = await supabase
        .from('support_conversations')
        .select('*')
        .eq('status', 'open')
        .order('createdAt', { ascending: false })
        .limit(1)
        .maybeSingle()
    
    if (existingConversation) {
        return { data: existingConversation, error: null }
    }
    
    // If no open conversation exists, create one
    return await createConversation()
} 